<ng-container *ngIf="loginDisplay; else guestMenu">
    <span class="d-none d-lg-inline-block btn btn-sm pl-0">Hi {{firstName}}</span>
    <button (click)="logout()" class="d-none d-lg-inline-block btn btn-dark btn-sm p-1">Sign Out</button>
</ng-container>
<ng-template #guestMenu>
    <button (click)="login()" class="d-none d-lg-inline-block btn btn-dark btn-sm p-1">Sign In</button>
</ng-template>
